"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DASHBOARD = exports.DASHBOARD_QBANK = void 0;
const client_1 = require("@apollo/client");
const fragments_1 = require("../../fragments");
exports.DASHBOARD_QBANK = (0, client_1.gql) `
  ${fragments_1.PICTURE_FIELDS}
  query Dashboard_Qbank($filter: MarksheetFilterInput!) {
    restricted {
      latestPastMarksheetId
      latestSessionId
      user {
        id
        settings {
          productSettings {
            examDate
            nextFeedbackDate
          }
        }
        completedQuestionsCount
        completedCorrectQuestionsCount
        completedIncorrectQuestionsCount
        completedCards {
          id
          createdAt
          updatedAt
          concept {
            id
            name
          }
          lastSeen
          reviewDate
          score
          iteration
          optimalFactor
          cardId
          card {
            id
            conceptId
            concept {
              id
              name
            }
            topic {
              id
              name
            }
            question
            explanation
            pictures {
              ...PictureFields
            }
          }
        }
        completedCardsCount
        completedGreenCardsCount
        completedYellowCardsCount
        completedRedCardsCount
        marksheetsCount
        dailyFeed {
          topics {
            id
            name
            typeId
            totalCards
            totalQuestions
            dailyFeedCards
          }
          id
          marks {
            id
            score
          }
          redCards
          yellowCards
          greenCards
          dailyTask
        }
        dailyProgress {
          date
          dateString
          intensity
          totalCorrect
          totalCount
        }
        userProgress {
          marksheetCount
          questionsCount
          daysInCurrentStreak
          daysInPreviousStreak
          daysInLongestStreak
        }
      }
      totalQuestions
      totalCards
      marksheets(filter: $filter) {
        results {
          id
          topicNames
          correct
          incorrect
          totalQuestions
          isTestMarksheet
        }
        total
      }
      topics(filter: 0) {
        id
        name
        entitlement {
          id
          name
          index
        }
        totalQuestions
        correctQuestions
        incorrectQuestions
        totalCards
        greenCards
        yellowCards
        redCards
        dailyFeedCards
      }
      universityLeaderboard(limit: 3) {
        updatedAt
        month {
          id
          name
          speciality
          rank
        }
      }
    }
  }
`;
exports.DASHBOARD = (0, client_1.gql) `
  ${fragments_1.PICTURE_FIELDS}
  query Dashboard($filter: MarksheetFilterInput!, $order: Int) {
    restricted {
      latestPastMarksheetId
      latestSessionId
      user {
        id
        settings {
          productSettings {
            examDate
            nextFeedbackDate
          }
        }
        universityId
        classYear
        completedQuestionsCount
        completedCorrectQuestionsCount
        completedIncorrectQuestionsCount
        completedCards {
          id
          createdAt
          updatedAt
          concept {
            id
            name
          }
          lastSeen
          reviewDate
          score
          iteration
          optimalFactor
          cardId
          card {
            id
            conceptId
            concept {
              id
              name
            }
            topic {
              id
              name
            }
            question
            explanation
            pictures {
              ...PictureFields
            }
          }
        }
        completedCardsCount
        completedGreenCardsCount
        completedYellowCardsCount
        completedRedCardsCount
        marksheetsCount
        dailyProgress {
          date
          dateString
          intensity
          totalCorrect
          totalCount
        }
        userProgress {
          marksheetCount
          questionsCount
          daysInCurrentStreak
          daysInPreviousStreak
          daysInLongestStreak
        }
      }
      totalQuestions
      totalCards
      marksheets(filter: $filter) {
        results {
          id
          topicNames
          correct
          incorrect
          totalQuestions
          isTestMarksheet
        }
        total
      }
      topics(filter: 0, order: $order) {
        id
        name
        entitlement {
          id
          name
          index
        }
        totalQuestions
        correctQuestions
        incorrectQuestions
        totalCards
        greenCards
        yellowCards
        redCards
        dailyFeedCards
      }
      universityLeaderboard(limit: 3) {
        updatedAt
        month {
          id
          name
          speciality
          rank
        }
      }
    }
  }
`;
